import { ButtonView, Locale, Plugin } from 'ckeditor5'

export default class AsteriskListButtonPlugin extends Plugin {
  public static readonly pluginName = 'AsteriskListButtonPlugin'

  init(): void {
    const editor = this.editor

    editor.ui.componentFactory.add('asterisk', (locale: Locale) => {
      const button = new ButtonView(locale)

      button.set({
        label: 'Asterisk Bullet',
        tooltip: true,
        withText: false,
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M10 3v14M4 7l12 6M4 13l12-6" />
        </svg>
        `,
      })

      this.listenTo(button, 'execute', () => {
        editor.model.change((writer) => {
          const text = writer.createText('* ')
          editor.model.insertContent(text)
        })
        editor.editing.view.focus()
      })

      return button
    })
  }
}
